import { useCallback, useEffect } from 'react';
import semver from 'semver';
import { App } from '@capacitor/app';
import { WebViewCache } from 'capacitor-plugin-webview-cache';
import { useDevice } from './useDevice';

/**
 * 清除webview缓存
 */
export const useClearWebviewCache = () => {
  const { checkIsApp } = useDevice();

  useEffect(() => {
    setTimeout(() => {
      clearWebviewCache();
    }, 2000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const clearWebviewCache = useCallback(() => {
    if (checkIsApp()) {
      App.getInfo().then(appInfo => {
        if (semver.gte(appInfo?.version, '1.9.0')) {
          console.log('handle clear webview cache');
          WebViewCache.clearCache().catch(e => {
            console.error('clear error', e);
          });
        }
      });
    }
  }, [checkIsApp]);
};
